export const CHECKED = "https://gw.alicdn.com/tfs/TB1Y9vlpwMPMeJjy1XcXXXpppXa-72-72.png";
export const UNCHECKED = "https://gw.alicdn.com/tfs/TB1PtN3pwMPMeJjy1XdXXasrXXa-72-72.png";



// WEBPACK FOOTER //
// ./packages/wxc-radio/type.js